import React, { lazy } from 'react';

const BackchargePolicyForm = lazy(() =>
  import('../BackchargePolicy/BackchargePolicyForm').then(module => ({
    default: module.BackchargePolicyForm,
  })),
);

const BackchargePolicyRoute = [
  {
    props: {
      exact: true,
      path: '/company-setup/submenu/:CompanyID/backcharge-policy',
    },
    component: <BackchargePolicyForm />,
  },
];

export default BackchargePolicyRoute;
